import DOMPurify from 'dompurify';

export function sanitizeEventDetails(value) {
  const clean = DOMPurify.sanitize(String(value || ''), {
    USE_PROFILES: { html: true },
  });

  return clean
    .replace(/<h1(\s[^>]*)?>/gi, '<h2$1>')
    .replace(/<\/h1>/gi, '</h2>')
    .replace(/<(p|h[1-6]|div)>(?:\s|&nbsp;|<br\s*\/?>)*<\/\1>/gi, '');
}
